import React, { useState, useEffect } from 'react'

// Deps
// import omit from 'lodash/omit'

// Functions
// import formatDate from 'functions/format-date';

// Partials
import Btn from 'views/shared/partials/btn'
import { InputForm, FormInput } from 'views/shared/partials/forms'
import Loader from 'views/shared/partials/loader'
// import { Table, TR, TD } from 'views/shared/partials/table'
// import Pricebox from 'views/shared/partials/pricebox'

// Services
import companyServices from 'services/company'

const additionalOptions = [
	{
		value: '',
		label: '-',
	},
	{
		value: '1',
		label: 'Ek Taksit',
	},
	{
		value: '2',
		label: 'Taksit Atlatma',
	},
]

const CompanyPaymentInstallmentModal = (props) => {
	const close = props.close;
	const installmentID = props.installmentID;
	const paymentTypeID = props.paymentTypeID;

	const [submitting, setSubmitting] = useState(false);
	const [installmentInfo, setInstallmentInfo] = useState(false);

	useEffect(() => {
		if(installmentID) {
			companyServices.getPaymentInstallment(installmentID).then((payload) => {
				let selectedAddition = additionalOptions.find((opt) => {
					return ((payload.joker_vadaa && opt.value === payload.joker_vadaa.toString()) || (opt.value === '' && payload.joker_vadaa === null));
				});
				//let selectedAddition = additionalOptions[0];
				setInstallmentInfo({...payload, joker_vadaa_opt: selectedAddition});
			}).catch(() => { close(); })
		}
		else {
			setInstallmentInfo(null);
		}
	}, [installmentID, close]);

	const submit = (formData) => {
		setSubmitting(true);

		if(installmentInfo) {
			formData.installment_id = installmentInfo.id;
		}
		else {
			formData.create_or_update = 'create';
			formData.company_payment_type_id = paymentTypeID;
		}

		companyServices.createOrUpdatePaymentInstallment(formData).then(() => {
			if(props.onSuccess) {
				props.onSuccess();
			}
			props.close();
		}).catch(() => {
		}).finally(() => {
			setSubmitting(false);
		})
	}

	return (
		<InputForm
			ignoreEmpty
			onSubmit={submit}
			className={props.className}>
			<div className="modal-header dark">
				<h1 className="header-title">{props.installmentID ? 'Taksit Seçeneği Düzenle' : 'Taksit Seçeneği Oluştur'}</h1>
				{props.closeBtn}
			</div>

			<div className="modal-content loader-container">
				<Loader loading={installmentInfo === false} />
				<div className="grid-container">
					<div className="row">
						<div className="col x6">
							<FormInput
								type="number"
								disabled={installmentInfo === false || submitting}
								label="Taban Fiyat"
								name="min_price"
								value={installmentInfo ? installmentInfo.min_price : undefined}
								validation={{
									required: 'Bir taban fiyat girmelisiniz.',
								}} />
								<div className="form-note error">Örn. 100 (100₺ için)</div>
						</div>
						<div className="col x6">
							<FormInput
								type="number"
								disabled={installmentInfo === false || submitting}
								label="Taksit Sayısı"
								name="installment_count"
								value={installmentInfo ? installmentInfo.installment_count : undefined}
								validation={{
									required: 'Taksit sayısı girmelisiniz.',
								}} />
								<div className="form-note error">Örn. 9</div>
						</div>
					</div>
					<div className="row">
						<div className="col x6">
							<FormInput
								type="text"
								disabled={installmentInfo === false || submitting}
								label="Taksit Açıklaması"
								name="installment_text"
								value={installmentInfo ? installmentInfo.installment_text : undefined}
								validation={{
									required: 'Bir taksit açıklaması girmelisiniz.',
								}} />
								<div className="form-note error">Örn. (9 + 2)</div>
						</div>
						<div className="col x6">
							<FormInput
								type="number"
								disabled={installmentInfo === false || submitting}
								label="Toplam Taksit Sayısı"
								name="installment_calculate"
								value={installmentInfo ? installmentInfo.installment_calculate : undefined}
								validation={{
									required: 'Toplam taksit sayısı girmelisiniz.',
								}} />
								<div className="form-note error">Örn. 11</div>
						</div>
					</div>
					<div className="row">
						<div className="col x6">
							<FormInput
								type="number"
								disabled={installmentInfo === false || submitting}
								label="Vade Farkı Oranı"
								name="ratio"
								value={installmentInfo ? installmentInfo.ratio : undefined}
								validation={{
									required: 'Vade farkı oranını girmelisiniz.',
								}} />
								<div className="form-note error">Örn. 2.2 (%2.2 için)</div>
						</div>
						<div className="col x6">
							<FormInput
								type="text"
								disabled={installmentInfo === false || submitting}
								label="Açıklama"
								name="description"
								value={installmentInfo ? installmentInfo.description : undefined} />
						</div>
					</div>
					<div className="row">
						<div className="col x6">
							<FormInput
								type="select"
								disabled={installmentInfo === false || submitting}
								label="Ödeme Türü"
								name="joker_vadaa"
								defaultValue={installmentInfo ? installmentInfo.joker_vadaa_opt : additionalOptions[0]}
								options={additionalOptions} />
							<div className="form-note error">Sadece Yapı Kredi Vadaa kampanyası için geçerlidir.</div>
						</div>
					</div>
				</div>
			</div>

			<div className="modal-controls">
				<Btn
					nude
					disabled={submitting}
					onClick={props.close}>
					Vazgeç
				</Btn>
				<Btn
					loading={submitting}
					disabled={submitting || installmentInfo === false}
					type="submit">
					{installmentID ? 'Kaydet' : 'Oluştur'}
				</Btn>
			</div>
		</InputForm>
	)
}

CompanyPaymentInstallmentModal.defaultProps = {
	className: '',
	containerClass: 'modal-company-payment-installment mobile-full',
	name: 'company-payment-installment',
}

export default CompanyPaymentInstallmentModal